import React, { FC } from 'react'
import BpmnModeler from '../components/modelers/BpmnModeler'
import DmnModeler from '../components/modelers/DmnModeler'
import FormModeler from '../components/modelers/FormModeler'
import Home from './HomePage'
interface ModelerProps {
  type: string
  file: string
  directoryPath: string
}

const Modeler: FC<ModelerProps> = ({ type, file, directoryPath }) => {
  // const [xml, setXml] = useState<any>(null)

  const getComponent = () => {
    switch (type) {
      case 'bpmn':
        return <BpmnModeler file={file} directoryPath={directoryPath} />
      // return <BpmnModeler onSave={setXml} initialXml={xml} />
      case 'dmn':
        return <DmnModeler file={file} directoryPath={directoryPath} />
      case 'form':
        return <FormModeler file={file} directoryPath={directoryPath} />
      default:
        return <Home />
    }
  }

  return getComponent()
}

export default Modeler
